import React from 'react';
import './social-button.css';

const SocialButton = ({ Icon, text, site, background, pressedSocial }) => {
  return (
    <>
    {/* // <button className="social-button" style={{ background }} onClick={pressedSocial}> */}
      <Icon className='icon' onClick={pressedSocial} />
			{/* <div>{text || 'Watch On'} {site}</div> */}
    {/* // </button> */}
    </>
  );
}

export default SocialButton;
